import type { ReactNode } from 'react';
import { Show, RedirectToSignIn, ClerkLoading, ClerkLoaded } from '@clerk/react';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Wraps children that require an authenticated user.
 *
 * - While Clerk is still loading, shows a thin loading state to avoid flashes.
 * - Once loaded, if the user is signed in, renders children.
 * - If the user is signed out, redirects to Clerk's sign-in flow.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return (
    <>
      <ClerkLoading>
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-sm text-slate-500 dark:text-slate-400">Loading…</div>
        </div>
      </ClerkLoading>
      <ClerkLoaded>
        <Show when="signed-in">{children}</Show>
        <Show when="signed-out">
          <RedirectToSignIn />
        </Show>
      </ClerkLoaded>
    </>
  );
}
